import { format } from 'date-fns'
import { useI18n, type ComposerTranslation } from 'vue-i18n'

const monthsList = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]
const daysList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

/**
 * This function do 2 things:
 * 1. Formatted the provided date (by using { format } from 'date-fns')
 * 2. Translate the possible "textural" part of the date (from the BO Local)
 *
 * @see Note: The library has a "translate build-in feature", but we don't use it to have better control over the translation of the dates.
 * @see `vue-app/src/vue/date-dns.ts`, if the choose otherwise
 */
export function doDateFnsFormatTranslate(
  dateParam: Date | number,
  formatParam: string,
  optionsParam?: {
    locale?: Locale
    weekStartsOn?: 0 | 1 | 2 | 3 | 4 | 5 | 6
    firstWeekContainsDate?: number
    useAdditionalWeekYearTokens?: boolean
    useAdditionalDayOfYearTokens?: boolean
  },
): string {
  const { t } = useI18n()
  // Date formatting
  let dateFormatted = format(dateParam, formatParam, optionsParam)
  // Month replacing traduction
  monthsList.forEach((month) => {
    dateFormatted = dateFormatted.replaceAll(month, t(month))
  })
  // Day replacing traduction
  daysList.forEach((day) => {
    dateFormatted = dateFormatted.replaceAll(day, t(day))
  })
  return dateFormatted
}

/**
 * Some component need to have the original language date (aka English)
 * This function will undo the translate of the date to correctly process the date
 */
export function undoDateFnsTranslate(
  dateParam: string,
  translateI18n: ComposerTranslation = useI18n().t,
): string {
  // Month replacing traduction
  monthsList.forEach((month) => {
    dateParam = dateParam.replaceAll(translateI18n(month), month)
  })
  // Day replacing traduction
  daysList.forEach((day) => {
    dateParam = dateParam.replaceAll(translateI18n(day), day)
  })
  return dateParam
}

/**
 * Define a date format according to the Date Fns lib
 * Default value can be provide, the default one is "MM/dd/yyyy"
 */
export function applyDateFnsConverter(date?: string, defaultValue: string = 'MM/dd/yyyy'): string {
  // "MM/DD/YYYY" is computed has not defined
  if (!date || date === 'MM/DD/YYYY') {
    date = defaultValue
  }
  // Actually no modification is necessary
  return date
}

/**
 * Depending on dateFormat width (nbr of character)
 * Return the supposed needed pixel width
 * (Minimal value is 130)
 * (Default character size is 10)
 */
export function calcDateFormatPixelWidth(dateFormat?: string) {
  return `${Math.max(130, (dateFormat ? dateFormat.length : 10) * 7 + 75)}px`
}
